import React from "react";

import { SelectedFiltersContext } from "./context";
import { useSelectedFilterMap } from "./hooks";

export const SelectedStateProvider: React.FC = ({ children }) => {
  const selectedFilters = useSelectedFilterMap();
  return (
    <SelectedFiltersContext.Provider value={selectedFilters}>
      {children}
    </SelectedFiltersContext.Provider>
  );
};
